//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Navigation from '@/components/Navigation.vue'
import SwoopLogo from '@/components/SwoopLogo'
import Button from '@/components/Button'

export default {
  name: 'ResponsiveLayout',

  components: {
    SwoopLogo,
    Navigation,
    Button
  },

  data() {
    return {
      quickViewPanelWidth: this.$q.screen.gt.sm
        ? this.$store.state.quickViewPanelWidth
        : this.$store.state.width
    }
  },

  computed: {
    sidebarOpen() {
      return (
        typeof this.$slots.sidebar !== 'undefined' &&
        this.$store.state.isSideBarOpen
      )
    },
    quickViewOpen() {
      return typeof this.$slots.quickview !== 'undefined'
    },
    sidebarPanelWidth() {
      return this.$q.screen.gt.sm ? 300 : this.$store.state.width
    }
  },

  methods: {
    // eslint-disable-next-line no-unused-vars
    handleMouseQuickviewResize({ evt, ...info }) {
      if (info.position.left > 370) {
        this.quickViewPanelWidth = this.$store.state.width - info.position.left
      } else {
        this.quickViewPanelWidth = this.$store.state.width - 370
      }
      if (info.isFinal) {
        this.$store.commit('set', [
          'quickViewPanelWidth',
          this.quickViewPanelWidth
        ])
      }
    },
    toggleSideBar(state) {
      this.$store.commit('set', ['isSideBarOpen', state])
    }
  }
}
